<template>
  <router-view />
  <Toast :toasts="toasts" @remove="remove" position="top" />
  <AppUpdateNotice />
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import Toast from '@/components/common/Toast.vue'
import AppUpdateNotice from '@/components/common/AppUpdateNotice.vue'
import { useToast } from '@/composables'
import { useAuthStore } from '@/stores/auth'

const { toasts, remove } = useToast()
const authStore = useAuthStore()

onMounted(() => {
  if (authStore.isAuthenticated) {
    authStore.refreshUserInfo()
    authStore.loadClubMemberships()
  }
})
</script>

<style>
/* 전역 스타일 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Noto Sans KR', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
